import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-input-hint',
  templateUrl: './input-hint.component.html',
  styleUrls: ['./input-hint.component.scss'],
})
export class InputHintComponent implements OnInit {
  @Input() message: string;
  @Input() type: 'info' | 'error' | 'warning' | 'success' = 'info';

  constructor() {}

  ngOnInit(): void {}
}
